import { extendObservable } from "mobx";

export default class CsrfToken {
  private headerName!: string;
  private parameterName!: string;
  private token!: string;

  public constructor(data?) {
    if (data != null) {
      extendObservable(this, data);
    }
  }

  public getHeaderName() {
    return this.headerName;
  }

  public setHeaderName(headerName: string): void {
    this.headerName = headerName;
  }

  public getParameterName() {
    return this.parameterName;
  }

  public setParameterName(parameterName: string): void {
    this.parameterName = parameterName;
  }

  public getToken() {
    return this.token;
  }

  public setToken(token: string): void {
    this.token = token;
  }
}
